import React, { useContext, useEffect, useState } from 'react';

import './LabelsNotFoundTable.css';
import B2BTable from '../../b2b-common/B2BTable';
import { toLocaleDateTime } from '../../b2b-common/helpers';


const LabelsNotFoundTable = ({ labelsPagedData, onSelectLabel, pagesCount, currentPage, onPageChange, className }) => {

    const headers = [
        { label: 'Date', align: 'left' },
        { label: 'Locale', align: 'center' },
        { label: 'Key', align: 'left' },
    ];

    const rows = labelsPagedData.content.map((label) => ({
        id: `${label.key}-${label.locale}`,
        cells: [
            { content: `${toLocaleDateTime(label.timeStamp, true)}`, align: 'left' },
            { content: `${label.locale}`, align: 'center' },
            { content: `${label.key}`, align: 'left' },
        ]
    }));

    const handleSelectRow = (rowInTable => {
        //console.log(rowInTable);
        onSelectLabel({
            "languageId": null,
            "locale": rowInTable.cells[1].content,
            "key": rowInTable.cells[2].content,
            "content": ""
        });
    })

    //console.log(rows);

    return <B2BTable
        pagesCount={pagesCount}
        currentPage={currentPage}
        onPageChange={onPageChange}
        headers={headers} rows={rows}
        onRowClick={handleSelectRow}
        className={className} />;
}

LabelsNotFoundTable.defaultProps = {
    labelsPagedData: { content: [] },
    onSelectUser: null,
    className: '',
};

export default LabelsNotFoundTable;
